import React from 'react'
import { NavLink } from 'react-router-dom'
import { LinearProgress, Table, TableBody, TableContainer, Typography } from '@mui/material'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { normalizedWarrantName } from '@finance-lab/utils/shared'
import { CompanyEventRow } from './CompanyEventRow'
import WarrantApi from '../../../../api/WarrantApi'

async function addIsinToWarrant(warrant, isin) {
    const warrantApi = new WarrantApi()

    if (isin.instrumentType !== 'warrant') return null

    if (!warrant || !isin) {
        console.error(`addIsinToWarrant: Missing ${warrant ? '' : 'issue'} ${isin ? '' : 'isin'}`)
        return null
    }

    const updatedWarrantIsin = await warrantApi.patchFields(warrant.id, { isinWarrant: isin.isin })

    return updatedWarrantIsin
}

export const CompanyWarrants = ({ warrants, selectedIsin, setSelectedIsin, onArchiveIsin }) => {
    if (!warrants) return <LinearProgress />
    if (warrants.length === 0) return <Typography variant='body1'>Inga teckningsoptioner hittades</Typography>

    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {warrants.map((warrant) => {
                        let dates = null
                        if (warrant.subscriptionPeriods?.length === 1) {
                            dates = `${formatDateYYYYMMDD(warrant.subscriptionPeriods[0].subStartDate)} - ${formatDateYYYYMMDD(warrant.subscriptionPeriods[0].subEndDate)}` // prettier-ignore
                        } else if (warrant.subscriptionPeriods?.length > 1) {
                            dates = 'Flera teckningsperioder'
                        }
                        return (
                            <CompanyEventRow
                                key={warrant.id}
                                event={warrant}
                                eventType='warrant'
                                selectedIsin={selectedIsin}
                                setSelectedIsin={setSelectedIsin}
                                addIsinToEntity={addIsinToWarrant}
                                onArchiveIsin={onArchiveIsin}
                            >
                                <NavLink to={`/admin/warrants/${warrant.id}`} target='_blank'>
                                    {normalizedWarrantName(warrant)}
                                    {!!warrant.unlisted && '(Onoterad)'}
                                </NavLink>
                                {dates && <i>{dates}</i>}
                            </CompanyEventRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
